import {
    setWithinPercentageRange,
    setWithinRange,
} from "@@/utilities/set-within-range";
import type { HSLA } from "./hsla-color/hsla-color";

const parseHslaRegEx =
    /^hsla?\((\d{1,3}),(\d{1,3})%,(\d{1,3})%(,([01]|(.\d.*)|(0.\d.*)|(\d.*)%))?\)$/i;
const parseCssHsla = (hsla: string): HSLA => {
    const parseResult = parseHslaRegEx.exec(hsla.replace(/\s/g, ""));
    parseHslaRegEx.lastIndex = 0;

    if (!parseResult) throw new Error("Bad hsl/hsla value: " + hsla);

    const hue = parseInt(parseResult[1], 10);
    const saturation = parseInt(parseResult[2], 10) / 100;
    const light = parseInt(parseResult[3], 10) / 100;

    const alpha = !parseResult[5]
        ? 1
        : parseResult[5].endsWith("%")
          ? parseInt(parseResult[5], 10) / 100
          : parseInt(parseResult[5], 10);

    return {
        hue: setWithinRange(hue, { min: 0, max: 360 }),
        saturation: setWithinPercentageRange(saturation),
        light: setWithinPercentageRange(light),
        alpha: setWithinPercentageRange(alpha),
    };
};

export { parseCssHsla };
